@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.forecasting-grid {
  .table {
    .react-table-header-row {
      display: flex;
      flex-direction: row;
      background-color: var(--default--background-color--14);
      border-bottom: 1px solid var(--table--border-color--2);
    }

    .react-table-header-row > div {
      padding: @space-8;
      font-size: var(--font-size-small, 12px);
      font-weight: 500;
      line-height: 18px;
      white-space: nowrap;
      text-align: right;

      &:nth-child(1) {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &:nth-child(2) {
        flex: 2;
        text-align: left;
      }

      &:nth-child(n + 3) {
        flex: 1;
      }
    }

    .react-table-body-row {
      display: flex;
      flex-direction: row;
      font-size: var(--font-size-small, 14px);
      line-height: 21px;
      border-bottom: 1px solid var(--table--border-color--2);
    }

    .react-table-body-row:hover {
      background-color: var(--default--background-color--14);
    }

    .cell {
      padding: @space-8;
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .expander-column {
      flex: 0 0 40px;
      min-width: 40px;
      max-width: 40px;
    }

    .product-column {
      flex: 3;
    }

    .numeric-column {
      flex: 1;
    }

    .cell:focus {
      outline: 2px solid var(--blue-600);
      outline-offset: -2px;
      position: relative;
      z-index: 1;
    }
  }
}
